export default "__VITE_ASSET__C59jKsTM__"